import { Observable } from 'rxjs';

export interface HealthIssueDetails {
  readonly description: string;
  readonly title: string;
  readonly cta?: string;
  readonly details?: string;
}

export abstract class HealthChecker {
  abstract getIssueDetails(): HealthIssueDetails;
  abstract getReport(): { [key: string]: unknown; };
  abstract hasIssue(): Observable<boolean>;
}
